<template>
  <div class="form" v-bind:class="{ 'half-opacity': isLoading }">
    <p class="font-weight-bold">{{ edificioNombre }}</p>
    <div class="form-group">
      <textarea class="form-control" id="parteDescripcion" rows="4" v-model="descripcion"></textarea>
    </div>
    <div class="row row-low-gap row-horas-de-trabajo">
      <div class="col-6">
        <p class="horas-title font-weight-bold">Horas normales</p>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="selectNormalesHoras" class="text-small">Horas</label>
              <select class="form-select" id="selectNormalesHoras" name="normalesHoras" v-model="normHoras">
                <option v-for="horas in horasOptions" v-bind:value="horas">{{horas}}</option>
              </select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="selectNormalesMinutos" class="text-small">Minutos</label>
              <select class="form-select" id="selectNormalesMinutos" name="normalesMinutos" v-model="normMinutos">
                <option v-for="minutos in minutosOptions" v-bind:value="minutos">{{minutos}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <p class="horas-title font-weight-bold">Horas extra</p>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="selectNormalesHoras" class="text-small">Horas</label>
              <select class="form-select" id="selectNormalesHoras" name="normalesHoras" v-model="extraHoras">
                <option v-for="horas in horasOptions" v-bind:value="horas">{{horas}}</option>
              </select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="selectNormalesMinutos" class="text-small">Minutos</label>
              <select class="form-select" id="selectNormalesMinutos" name="normalesMinutos" v-model="extraMinutos">
                <option v-for="minutos in minutosOptions" v-bind:value="minutos">{{minutos}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h3>Piezas y materiales</h3>
    <div class="materiales-list">
      <ul class="list-group list-group-flush">
        <li class="list-group-item border-top-dashed" v-for="(material, index) in materiales">
          <div class="row row-low-gap">
            <div class="col">
              <div class="row">
                <div class="col-12 form-group">
                  <input type="text" class="form-control" name="descripcion" placeholder="Descripción" v-model="material.descripcion">
                </div>
                <div class="col-6 form-group">
                  <input type="text" class="form-control" name="descripcion" placeholder="Cantidad" v-model="material.cantidad">
                </div>
                <div class="col-6 form-group">
                  <input type="text" class="form-control" name="descripcion" placeholder="Coste" v-model="material.coste">
                </div>
              </div>
            </div>
          </div>
          <a class="icon-delete icon-delete-link icon-btn" v-on:click="onRemoveMaterialClick(index)">&nbsp;</a>
        </li>
      </ul>
      <p class="add-item text-right pt-2 pb-2"><a v-on:click="onAddMaterialClick">Añadir material <i class="icon-circled-add-link icon-text-btn">&nbsp;</i></a></p>
      <!--<p class="materiales-total pt-2 pb-2 border-top">Total: &nbsp;€</p>-->
      <div class="aceptar pt-2 pb-2 border-top">
        <div class="row justify-content-between">
          <div class="col-5">
            <button class="btn btn-secondary btn-block" data-bs-dismiss="modal" v-on:click="updateForm(false)"><i class="icon-close-cross-white icon-text">&nbsp;</i> DESCARTAR</button>
          </div>
          <div class="col-6 col-offset-2 text-right">
            <button class="btn btn-primary btn-block" v-on:click="updateForm(true)">GUARDAR</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import apiService from '../../services/api-service.js';

function getNumericOptions(first, last, step) {
  var i, options;
  options = [];
  for(i = first; i <= last; i+=step) {
    options.push(i);
  }
  return options;
}

class MaterialItem {
  constructor(descripcion, cantidad, coste) {
    this.descripcion = descripcion;
    this.cantidad = cantidad;
    this.coste = coste;
  }
}

export default {
  props: [
    'postUrl',
    'edificioNombre',
    'ticketId'
  ],
  data() {
    return {
      horasOptions: getNumericOptions(0, 99, 1),
      minutosOptions: getNumericOptions(0, 45, 15),
      isLoading: false,
      descripcion: "",
      normHoras: 0,
      normMinutos: 0,
      extraHoras: 0,
      extraMinutos: 0,
      materiales: []
    };
  },
  created(event) {
    isLoading: true;
    this.updateForm(false);
  },
  methods: {
    onAddMaterialClick: function() {
      this.materiales.push(new MaterialItem('', '', ''));
      return false;
    },
    onRemoveMaterialClick: function(index) {
      this.materiales.splice(index, 1);
      return false;
    },
    updateForm: function(commit) {
      this.isLoading = true;
      axios({
        method: "post",
        url: this.postUrl,
        params: {
          commit: commit ? "1" : "0",
          descripcion: this.descripcion,
          ticketId: this.ticketId,
          normHoras: this.normHoras,
          normMinutos: this.normMinutos,
          extraHoras: this.extraHoras,
          extraMinutos: this.extraMinutos,
          materiales: this.materiales.map(material => {
            return JSON.stringify({
              descripcion: material.descripcion,
              cantidad: material.cantidad,
              coste: material.coste,
            });
          })
        }
      }).then(response => {
        this.isLoading = false;
        if(response.data.status == apiService.STATUS_OK) {
          this.descripcion = response.data.descripcion;
          this.normHoras = response.data.normHoras;
          this.normMinutos = response.data.normMinutos;
          this.extraHoras = response.data.extraHoras;
          this.extraMinutos = response.data.extraMinutos;
          this.materiales = [];
          for(var i in response.data.materiales) {
            this.materiales.push(new MaterialItem(
              response.data.materiales[i].descripcion,
              response.data.materiales[i].cantidad,
              response.data.materiales[i].coste
            ));
          }
        }
        if(commit) {
          location.reload();
        }
      }).catch(error => {
        console.log(error);
      });
      return false;
    },
    getMaterialesOfKey: function(key) {
      return this.materiales.map(obj => {
        return obj[key];
      });
    }
  }
};

</script>
